<template>
  <div>
    <transition name="message-mask-fade">
      <div v-show="panelVisible" class="message-center-mask" @click="closePanel" />
    </transition>
    <transition name="message-panel-fade">
      <div v-show="panelVisible" class="message-center-panel" @click.stop>
        <div class="message-panel-header">
          <h2 class="message-panel-title">消息中心</h2>
          <i class="el-icon-close message-panel-close" @click="closePanel" />
        </div>
        <div class="message-panel-list">
          <div v-for="item in messages" :key="item.id" class="message-item"
            :class="{ 'is-general': item.type === 'general' }" @click="onItemClick(item)">
            <!-- 项目邀请 - 待处理 -->
            <template v-if="item.type === 'invitation' && item.status === 'pending'">
              <div class="message-item-row">
                <div class="icon-invite-pending">
                  <i class="el-icon-user" />
                  <span class="invite-plus">+</span>
                </div>
                <div class="message-item-body">
                  <div class="message-line">项目邀请</div>
                  <div class="message-line message-line--content">{{ item.content }}</div>
                  <div class="message-line">{{ item.date }}</div>
                  <div class="invite-actions" @click.stop>
                    <button type="button" class="btn-accept" @click="handleAccept(item)">
                      <i class="el-icon-check" />
                      接受
                    </button>
                    <button type="button" class="btn-reject" @click="handleReject(item)">拒绝</button>
                  </div>
                </div>
              </div>
            </template>

            <!-- 项目邀请 - 已接受 -->
            <template v-else-if="item.type === 'invitation' && item.status === 'accepted'">
              <div class="message-item-row">
                <div class="icon-status icon-status-ok">
                  <i class="el-icon-check" />
                </div>
                <div class="message-item-body">
                  <div class="message-line">邀请已经接受</div>
                  <div class="message-line message-line--content message-line--clamp">
                    {{ item.content }}
                  </div>
                  <div class="message-line">{{ item.date }}</div>
                </div>
              </div>
            </template>

            <!-- 项目邀请 - 已拒绝 -->
            <template v-else-if="item.type === 'invitation' && item.status === 'rejected'">
              <div class="message-item-row">
                <div class="icon-status icon-status-bad">
                  <i class="el-icon-close" />
                </div>
                <div class="message-item-body">
                  <div class="message-line">邀请已经拒绝</div>
                  <div class="message-line message-line--content message-line--clamp">
                    {{ item.content }}
                  </div>
                  <div class="message-line">{{ item.date }}</div>
                </div>
              </div>
            </template>

            <!-- 普通消息 -->
            <template v-else-if="item.type === 'general'">
              <div class="message-item-row message-item-row--simple">
                <div class="message-item-body message-item-body--full">
                  <div class="message-line message-line--clamp">
                    {{ item.summary || item.title }}
                  </div>
                  <div class="message-line">{{ item.date }}</div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </transition>

    <el-dialog :visible.sync="detailVisible" :append-to-body="true" :modal-append-to-body="true" :show-close="false"
      :close-on-click-modal="true" custom-class="message-detail-dialog" width="800px" :z-index="3200"
      modal-class="message-detail-backdrop">
      <div class="message-detail">
        <div class="message-detail-header">
          <div class="message-detail-header-left">
            <div class="message-detail-bell">
              <i class="el-icon-bell" />
            </div>
            <span class="message-detail-h-title">消息详情</span>
          </div>
          <i class="el-icon-close message-detail-close" @click="detailVisible = false" />
        </div>
        <div class="message-detail-body-wrap" v-if="activeDetail">
          <div class="message-detail-body-inner">
            <div class="message-detail-top">
              <h3 class="message-detail-article-title">{{ activeDetail.title }}</h3>
              <span class="message-detail-article-date">{{ activeDetail.date }}</span>
            </div>
            <p v-if="activeDetail.intro" class="message-detail-intro">{{ activeDetail.intro }}</p>
            <ul v-if="activeDetail.bullets && activeDetail.bullets.length" class="message-detail-bullets">
              <li v-for="(b, i) in activeDetail.bullets" :key="i" class="message-detail-li">
                <span class="message-detail-check"><i class="el-icon-check" /></span>
                <span class="message-detail-btext">{{ b }}</span>
              </li>
            </ul>
            <p v-if="activeDetail.footer" class="message-detail-footer">{{ activeDetail.footer }}</p>
          </div>
        </div>
        <div class="message-detail-footer-bar">
          <button type="button" class="btn-gotit" @click="detailVisible = false">知道了</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { EventBus,EVENTS } from "@/utils/eventBus";

export default {
  name: "MessageCenter",
  data() {
    return {
      panelVisible: false,
      detailVisible: false,
      activeDetail: null,
      messages: [
        {
          id: "1",
          type: "invitation",
          status: "pending",
          content: "戏精82351 邀请你加入项目「魔人」，角色为 editor",
          date: "2026-04-23",
        },
        {
          id: "2",
          type: "invitation",
          status: "accepted",
          content: "戏精82351 邀请你加入项目「魔人」…",
          date: "2026-04-23",
        },
        {
          id: "3",
          type: "invitation",
          status: "rejected",
          content: "戏精82351 邀请你加入项目「魔人」…",
          date: "2026-04-23",
        },
        {
          id: "4",
          type: "general",
          title: "【快影兔产品更新】戏精们，全局导演设定升级啦 🚀",
          summary: "【快影兔产品更新】戏精们，全局导演设定升级啦 🚀",
          date: "2026-04-23",
          detail: {
            title: "【快影兔产品更新】戏精们，全局导演设定升级啦🚀",
            date: "2026-04-23",
            intro: "想自定义全局风格？想让 AI 读懂剧本，直接生成本剧专属导演设定？",
            bullets: [
              "[全局导演设定] 在创作入口一键写入「本剧」导演语汇，后续分镜/镜头会优先对齐该设定。",
              "[全局导演设定] 支持参考片、对标导演风格，让 AI 先读懂再生成。",
              "[全局导演设定] 可随剧本迭代，随时增删与收敛导演关键词。",
              "[高阶技巧] 搭配主体、场景、镜头表使用，全链路风格更稳。",
            ],
            footer: "更多 [高阶技巧]，如参考经典作品、典型导演等等，快去探索吧少年！✨",
          },
        },
      ],
    };
  },
  mounted() {
    EventBus.$on(EVENTS.SHOW_MESSAGE_CENTER,this.openPanel);
  },
  beforeDestroy() {
    EventBus.$off(EVENTS.SHOW_MESSAGE_CENTER,this.openPanel);
  },
  methods: {
    openPanel() {
      this.panelVisible = true;
    },
    closePanel() {
      this.panelVisible = false;
      this.detailVisible = false;
    },
    onItemClick(item) {
      if(item.type !== "general") return;
      this.activeDetail = item.detail
        ? { ...item.detail,title: item.detail.title || item.title,date: item.detail.date || item.date }
        : {
          title: item.title,
          date: item.date,
          intro: item.content || "",
          bullets: [],
          footer: "",
        };
      this.detailVisible = true;
    },
    handleAccept(item) {
      this.$set(item,"status","accepted");
      this.$message.success("已接受邀请");
    },
    handleReject(item) {
      this.$set(item,"status","rejected");
      this.$message.info("已拒绝邀请");
    },
  },
};
</script>

<style lang="scss" scoped>
// 列表侧栏遮罩：加深，点击关闭
.message-center-mask {
  position: fixed;
  inset: 0;
  z-index: 2990;
  background: rgba(0, 0, 0, 0.81);
  pointer-events: auto;
}

.message-mask-fade-enter-active,
.message-mask-fade-leave-active {
  transition: opacity 0.24s ease;
}

.message-mask-fade-enter,
.message-mask-fade-leave-to {
  opacity: 0;
}

// 侧栏消息列表：从屏幕最左侧滑出，盖住主导航
.message-center-panel {
  --msg-font: 15px;
  --msg-lh: 1.5;
  --msg-color: #ffffff;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 340px;
  max-width: min(340px, 100vw);
  z-index: 3000;
  background: #1f1f1f;
  display: flex;
  flex-direction: column;
  font-size: var(--msg-font);
  line-height: var(--msg-lh);
  color: var(--msg-color);
  box-shadow: 8px 0 32px rgba(0, 0, 0, 0.4);
}

.message-panel-fade-enter-active,
.message-panel-fade-leave-active {
  transition: transform 0.28s ease, opacity 0.22s ease;
}

.message-panel-fade-enter,
.message-panel-fade-leave-to {
  opacity: 0.96;
  transform: translateX(-100%);
}

.message-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 14px;
  flex-shrink: 0;
}

.message-panel-title {
  margin: 0;
  font-size: var(--msg-font);
  font-weight: 500;
  color: var(--msg-color);
}

.message-panel-close {
  font-size: 16px;
  color: var(--msg-color);
  cursor: pointer;
  padding: 4px;
  opacity: 0.85;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
}

.message-panel-list {
  flex: 1;
  overflow-y: auto;
  padding: 12px 14px 24px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #3d3d3d;
    border-radius: 3px;
  }
}

.message-item {
  margin: 0 -6px;
  padding: 14px 6px;
  border-radius: 8px;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }

  &.is-general {
    cursor: pointer;
  }
}

.message-item-row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.message-item-row--simple {
  padding-left: 0;
}

.icon-invite-pending {
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 8px;
  // border: 2px solid #8b5cf6;
  color: #a78bfa;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;

  .el-icon-user {
    font-size: 20px;
  }

  .invite-plus {
    position: absolute;
    right: 2px;
    bottom: 2px;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
  }
}

.icon-status {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 14px;
  color: #fff;
  margin-top: 2px;

}

.icon-status-ok {
  background: #22c55e;
}

.icon-status-bad {
  background: #ef4444;
}

.message-item-body {
  min-width: 0;
  flex: 1;

  &--full {
    flex: 1;
  }
}

// 各类型消息：同一字号与颜色
.message-line {
  font-size: var(--msg-font);
  line-height: var(--msg-lh);
  font-weight: 400;
  color: var(--msg-color);
  margin-bottom: 6px;

  &:last-of-type {
    margin-bottom: 0;
  }

  &--clamp {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 6px;
  }

  // 邀请类正文：较标题/日期略小、略浅
  &--content {
    font-size: 14px;
    line-height: 1.45;
    color: #bbbbbb;
  }
}

.invite-actions {
  display: flex;
  gap: 10px;
  margin-top: 12px;
  justify-content: flex-end;
}

.btn-accept {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 22px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(90deg, #5eb733 0%, #37f16c 100%);

  .el-icon-check {
    font-size: var(--msg-font);
    font-weight: bold;
  }

  &:hover {
    filter: brightness(1.05);
  }
}

.btn-reject {
  padding: 6px 33px;
  border: none;
  border-radius: 6px;
  font-size: var(--msg-font);
  color: #e5e5e5;
  cursor: pointer;
  background: #2d2d2d;

  &:hover {
    background: #3d3d3d;
  }
}

// 详情弹窗（z-index 由 el-dialog 指定，高于侧栏）
::v-deep .message-detail-dialog {
  max-width: 92vw;
  background: #1a1a1a;
  border-radius: 12px;
  border: 1px solid #2d2d2d;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }
}

.message-detail {
  color: #fff;
}

.message-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 14px;
}

.message-detail-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.message-detail-bell {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #8de446 0%, #61e06c 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0f172a;

  .el-icon-bell {
    font-size: 20px;
  }
}

.message-detail-h-title {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.message-detail-close {
  font-size: 22px;
  color: #888;
  cursor: pointer;
  padding: 4px;

  &:hover {
    color: #fff;
  }
}

.message-detail-body-wrap {
  padding: 16px 20px 8px;
}

.message-detail-body-inner {
  background: #0d0d0d;
  border-radius: 10px;
  padding: 16px 16px 18px;
  border: 1px solid #262626;
}

.message-detail-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.message-detail-article-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  line-height: 1.5;
  flex: 1;
  min-width: 0;
}

.message-detail-article-date {
  font-size: 14px;
  color: #9ca3af;
  flex-shrink: 0;
  font-weight: 400;
}

.message-detail-intro {
  margin: 0 0 14px;
  font-size: 14px;
  color: #d4d4d4;
  line-height: 1.5;
}

.message-detail-bullets {
  margin: 0;
  padding: 0;
  list-style: none;
}

.message-detail-li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #e5e5e5;
  line-height: 1.5;

  &:last-child {
    margin-bottom: 0;
  }
}

.message-detail-check {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 3px;
  background: #22c55e;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;

  .el-icon-check {
    font-size: 12px;
    color: #fff;
    font-weight: bold;
  }
}

.message-detail-btext {
  flex: 1;
}

.message-detail-footer {
  margin: 14px 0 0;
  font-size: 14px;
  color: #d4d4d4;
  line-height: 1.5;
}

.message-detail-footer-bar {
  padding: 12px 20px 20px;
  display: flex;
  justify-content: flex-end;
}

.btn-gotit {
  padding: 10px 28px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  cursor: pointer;
  background: linear-gradient(135deg, #9fe537 0%, #51de79 100%);

  &:hover {
    filter: brightness(1.05);
  }
}
</style>

<!-- 仅作用于本弹窗的遮罩（通过 el-dialog modal-class 挂到 .v-modal） -->
<style lang="scss">
.v-modal.message-detail-backdrop {
  background: rgba(0, 0, 0, 0.75) !important;
  opacity: 1 !important;
}
</style>
